module.exports = __webpack_public_path__ + "media/src/application/images/logo-h-2f1a688597fd017245134696c396e620.png";